<script>
import { BSkeletonTable } from "bootstrap-vue";

export default {
  extends: BSkeletonTable
};
</script>